<template>
  <!-- Navigation menu (Theme / Country / Itinerary) -->
  <div id="navigation-menu-container">
    <div id="navigation-menu" v-if="!lessThan949">
      <ul>
        <li id="navigation-menu-theme" class="navigation-menu-item">
          <a href="#explore-by-theme" v-if="home">Explore by Theme</a>
          <router-link :to="{ name: 'home', hash: '#explore-by-theme' }" v-else>
            Explore by Theme
          </router-link>
        </li>
        <li id="navigation-menu-country" class="navigation-menu-item">
          <a href="#explore-by-country" v-if="home">Explore by Country</a>
          <router-link
            :to="{ name: 'home', hash: '#explore-by-country' }"
            v-else
          >
            Explore by Country
          </router-link>
        </li>
        <li id="navigation-menu-itinerary" class="navigation-menu-item">
          <a href="#explore-by-itinerary" v-if="home">Explore by Itinerary</a>
          <router-link
            :to="{ name: 'home', hash: '#explore-by-itinerary' }"
            v-else
          >
            Explore by Itinerary
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <div id="temporary-banner" v-if="$route.name === 'countries'">
      <a @click="displayNotice = true">Click Here For Explore by Country Notice</a>
    </div>
    <div id="temporary-text" v-if="displayNotice">
      <div id="text-wrapper">
        <div id="text">
          <p>Dear Visitor,</p>
          <p>Due to testing and adding new functions to the site, you may come across a few pages that do not display properly or are incomplete. This will be resolved soon.</p>
          <p>Thank you for your understanding.</p>
          <p>Your MWNF Team</p>
        </div>
        <a @click="displayNotice = false">Close</a>
      </div>
    </div> -->
    <!-- <div id="wip-banner">
    Thank you for visiting Explore. This website is a work-in-progress. Follow us on social media (links below) to be the first to hear about our launch in October 2020.
  </div> -->
  </div>
</template>

<script>
import media from "../mixins/media.js";
export default {
  name: "NavigationMenu",
  mixins: [media],
  data() {
    return {
      home: true,
      lessThan949: window.matchMedia("(max-width: 949px)").matches,
      displayNotice: false
    };
  },
  watch: {
    $route(to, from) {
      this.setHome(this.$route.name);
    },
  },
  methods: {
    setHome: function (name) {
      if (name === "home") {
        this.home = true;
      } else {
        this.home = false;
      }
    },
  },
  mounted() {
    this.setHome(this.$route.name);
  },
};
</script>

<style scoped lang="scss">
#navigation-menu-container {
  width: 100%;
}
#navigation-menu {
  width: 100%;
}

#navigation-menu ul {
  @include flex-center;
  width: 100%;
  list-style: none;
}
.navigation-menu-item {
  @include font-size-4;
  height: 50px;
  width: 100%;
  background-color: $dark-green;
}
.navigation-menu-item a {
  @include flex-center;
  height: 100%;
  width: 100%;
  color: $white;
  text-decoration: none;
}
#navigation-menu-theme {
  border-right: 1px solid $medium-green;
}
#navigation-menu-country {
  border-left: 1px solid $medium-green;
  border-right: 1px solid $medium-green;
}
#navigation-menu-itinerary {
  border-left: 1px solid $medium-green;
}

#temporary-banner {
  @include flex-center;
  @include headings;
  @include font-size-4;
  background-color: #ad190e;
  color: white;
  text-align: center;
  padding: 15px 50px;
}
#temporary-text {
  @include flex-center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(black, 0.6);
  z-index: 500;
}
  #text-wrapper {
    color: white;
    background-color: #006950;
    padding: 30px;
  }
    #text {
      width: 500px;
    }
      #text p {
        margin-bottom: 10px;
      }
    #text-wrapper a {
      @include flex-center;
      font-size: 11px;
      text-decoration: underline;
      margin-top: 20px;
    }

// #wip-banner {
//   @include flex-center;
//   @include headings;
//   @include font-size-4;
//   background-color: #ad190e;
//   color: white;
//   text-align: center;
//   padding: 30px 50px;
// }

@media only screen and (max-width: 1199px) {
  #navigation-menu ul {
    flex-direction: column;
  }
  #navigation-menu-theme {
    border-right: none;
    border-bottom: 1px solid $medium-green;
  }
  #navigation-menu-country {
    border-left: none;
    border-right: none;
    border-top: 1px solid $medium-green;
    border-bottom: 1px solid $medium-green;
  }
  #navigation-menu-itinerary {
    border-top: 1px solid $medium-green;
    border-left: none;
  }
  #wip-banner {
    @include font-size-5;
  }
}

@media only screen and (max-width: 599px) {
  #text {
    width: 100%;
  }
}

@media only screen and (max-width: 499px) {
  #wip-banner {
    @include font-size-6;
    padding: 20px 40px;
  }
}
</style>
